<template>
  <div class="frontpage">
    <Header
      :serviceClass="user.serviceClass"
      :msisdn="user.formattedMsisdn"
      :validUntil="validUntil"
    />
    <div class="container">
      <PackageCard />
      <!-- Navi -->
      <ul class="prepaid__navi">
        <li v-if="config.showRoaming">
          <router-link
            class="icon icon__settings"
            :to="'/safetynumbers'"
            v-t="'safety_numbers.title'"
          ></router-link>
        </li>
        <li v-if="config.showTransaction">
          <router-link
            class="icon icon__euro"
            :to="'/accounthistory'"
            v-t="'account_history.title'"
          ></router-link>
        </li>
        <li v-if="config.showSafety">
          <router-link
            class="icon icon__data"
            :to="'/dataroaming'"
            v-t="'roaming.title'"
          ></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import serviceClassConfig from '@/service-class-config.json';
import moment from 'moment';
import Header from '../components/Header';
import PackageCard from '../components/PackageCard';

export default {
  components: {
    Header,
    PackageCard,
  },
  computed: {
    ...mapGetters('user', ['user']),
    validUntil() {
      return moment(this.user.validUntil).format('D.M.YYYY');
    },
    config() {
      return serviceClassConfig[this.user.serviceClassGroup];
    },
  },
  methods: {
    ...mapActions('user', ['logout']),
  },
};
</script>

<style lang="scss" scoped>
$black: #000;
$white: #fff;

$success: #4cd964;

.prepaid__navi {
  list-style-type: none;
  margin: 20px 0;
  padding: 0;
  border-radius: 2px;
  overflow: hidden;
  @include block-shadow();

  li {
    margin: 0;
    padding: 0;
    margin-bottom: 2px;

    a {
      display: block;
      position: relative;
      padding: 15px 0 15px 55px;
      color: $almost-black;
      text-decoration: none;
      background: white;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        right: 20px;
        border-style: solid;
        border-color: $dark-gray;
        border-width: 0 1.5px 1.5px 0;
        width: 7.5px;
        height: 7.5px;
        transform: translateY(-50%) rotate(-45deg);
      }
    }
  }

  .icon {
    background-color: white;
    background-repeat: no-repeat;
    background-size: 22px 22px;
    background-position: 20px center;

    &__settings {
      background-image: url(~@/assets/svg/icon_control.svg);
    }
    &__euro {
      background-image: url(~@/assets/svg/icon_euro.svg);
    }
    &__data {
      background-image: url(~@/assets/svg/icon_data.svg);
    }
    &__payment {
      background-image: url(~@/assets/svg/icon_payment.svg);
    }
  }
}
</style>
